import { Autoplay, Pagination, EffectFade } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

import Image from "@/atoms/Image";
import Para from "@/atoms/text/Para";
import H2 from "@/atoms/text/H2";
import H3 from "@/atoms/text/H3";
import { RoundedTickIcon, PointArrowIcon } from "@/atoms/Icons";

const ProgressBarSwiper = ({ slideData, title, description }) => {
  return (
    <section className="progressBarSwiper bc-blue-light pv-7">
      <div className="container">
        <H2 className="bold mb-5" dangerouslySetInnerHTML={{ __html: title }} />
        <Para desktopSize="lg" mobileSize="lg" className="mb-7">
          {description}
        </Para>

        <Swiper
          modules={[Autoplay, Pagination, EffectFade]}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          effect="fade"
          pagination={{
            el: ".swiper-progress-bar",
            clickable: true,
          }}
          speed={1000}
          loop
        >
          <div className="swiper-progress-bar fx fx--sb"></div>
          {slideData.map((slide, index) => (
            <SwiperSlide key={index}>
              <div className="fx fx--sb fx--cv mb-5">
                <H3 desktopSize="sm" mobileSize="xs" className="bold">
                  {slide.title}
                  <span className="dot">.</span>
                </H3>
                <a href={slide.link} className="arrow-btn">
                  <PointArrowIcon
                    className="arrow-icon"
                    color="#33393D"
                    width="12"
                    height="12"
                  />
                </a>
              </div>
              <ul className="mb-7">
                {slide.items.map((item, idx) => (
                  <li key={idx} className="mb-3 fx fx-v">
                    <RoundedTickIcon className="mr-2" />
                    <Para desktopSize="lg" mobileSize="lg">
                      {item}
                    </Para>
                  </li>
                ))}
              </ul>
              <Image
                fileName={slide.image}
                fileFormat="png"
                mobileWidth="335"
                desktopWidth="540"
                alt={slide.title}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <style jsx>
        {`
          .arrow-btn {
            width: 24px;
            height: 24px;
          }
        `}
      </style>
    </section>
  );
};

export default ProgressBarSwiper;
